// Onboarding wizard config — step definitions + goal chips.
// Kept separate so config edits don't touch the wizard container.
export const ONBOARDING_STEPS = [
  { key: "welcome",  title: "Welcome to Career OS", subtitle: "Your career operating system — for the next 20 years, not the next job." },
  { key: "resume",   title: "Upload your resume",   subtitle: "We'll parse it with AI and pre-fill your profile in seconds." },
  { key: "role",     title: "Your current role",    subtitle: "So we can benchmark your salary and career progression." },
  { key: "location", title: "Where are you based?", subtitle: "Country + region unlocks localized advice — the right currency, tax context, retirement vehicles, and employment law. Nothing here is shown on your public profile." },
  { key: "dob",      title: "How old are you?",     subtitle: "Age helps the AI reason about life stage, risk tolerance, and time horizon. You can skip this — but you'll get sharper advice with it." },
  { key: "goals",    title: "Your career goals",    subtitle: "Where do you want to be in 5 years?" },
  { key: "salary",   title: "Salary target",        subtitle: "We'll use this to calculate lifetime earnings and gaps." },
  { key: "done",     title: "You're set!",          subtitle: "Generating personalized AI recommendations now…" },
];

export const GOAL_CHIPS = [
  "Find a new job", "Increase salary", "Become a manager", "Become an executive",
  "Switch industries", "Work remotely", "Start a business", "Improve work-life balance",
  "Retire early",
];

// Which fields are required to move forward on a given step.
export function canProceedFromStep(stepKey, profile) {
  if (stepKey === "role")   return !!(profile.current_role || "").trim();
  if (stepKey === "goals")  return (profile.career_goals || []).length > 0;
  if (stepKey === "salary") return !!profile.current_salary;
  return true;
}
